import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingFeedbackListingComponent } from './pending-feedback-listing.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PendingFeedbackListingComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterModule
  ],
  exports: [
    PendingFeedbackListingComponent
  ]
})
export class PendingFeedbackListingModule { }